import script from "./ImageModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImageModal.vue?vue&type=script&lang=ts&setup=true"

import "./ImageModal.vue?vue&type=style&index=0&id=5da88641&lang=scss"

const __exports__ = script;

export default __exports__